import request from 'local_modules/request'
import { reducers, getState } from 'redux/core'
import moment from 'moment'
import { constants, modals } from 'helpers'
import actions from 'redux/actions'


const setFetching = (isFetching) => reducers.marketplace.customerTicketPage.setFetching(isFetching)

const setStep = (step) => reducers.marketplace.customerTicketPage.setStep(step)

const setStepData = (stepData) => reducers.marketplace.customerTicketPage.setStepData(stepData)

const fetchTickets = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.ticket + `/${tool}`)
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.customerTicketPage.setTickets(data))
    .catch((error) => console.log(error))
}

const fetchCategories = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.statisticsCategories + `/${tool}`)
    .then(({ data }) => data)
    .then((categories) => reducers.marketplace.customerTicketPage.setCategories(categories))
    .catch((error) => console.log(error))
}

const handlePayment = (data) => {
  // const { marketplace: { layersNavigation: { tool } } } = getState()

  const {
    tariff,
    gender, dateOfBirth, label,
    email,
    phone,
    firstName, lastName, middleName,
  } = data

  actions.ui.showRequestLoader('Не закрывайте окно, ваш запрос на оплату обрабатывается')

  return request.post(constants.marketplace.booking, {
    tariff: tariff.id ? { id: tariff.id } : undefined,
    tariffCategory: { id: tariff.category.id },
    subscriber: {
      email,
      // phone, // temporary remove phone field
      gender, label,
      firstName, lastName, middleName,
      birthInt: {
        y: moment(dateOfBirth, 'DDMMYYYY').format('YYYY'),
        m: moment(dateOfBirth, 'DDMMYYYY').format('MM'),
        d: moment(dateOfBirth, 'DDMMYYYY').format('DD'),
      },
    },
  })
    .then(({ data }) => data)
    .then((data) => {
      const {
        status,
        errormsg,
        redirectUrl,
      } = data || {}

      if (errormsg) {
        actions.ui.hideRequestLoader()
        actions.modals.open(modals.Dialog, {
          title: 'Оплата не прошла',
          text: errormsg,
        })
      }
      else if (redirectUrl) {
        window.location.href = redirectUrl
      }
      else {
        console.log(data)
        actions.ui.hideRequestLoader()
      }

      return data
    })
    .catch((error) => {
      console.log(error)
      actions.ui.hideRequestLoader()
    })
}

export default {
  setFetching,
  setStepData,
  setStep,
  fetchTickets,
  fetchCategories,
  handlePayment,
}
